export const BASEURL = process.env.NODE_ENV === 'development' ? 
                        "http://localhost:5172/api" : 
                        "https://server.mydigitalbriefcase.fr/TeamStick/api";

export const GRAPH_RIGHTS_SOCPE = ["User.Read", "User.ReadBasic.All"];